// removed by extract-text-webpack-plugin
module.exports = {"component":"Login__component___riB9F","wrapper":"Login__wrapper___IYuo4","title":"Login__title___HgGrW","text":"Login__text___3KTi5","input":"Login__input___21fXk","button":"Login__button___2NKRn","invalid":"Login__invalid___2MAqy"};


//////////////////
// WEBPACK FOOTER
// ./src/admin/components/Login.css
// module id = 401
// module chunks = 0